import React, { useState } from 'react';
import TextField from '../../Form/TextField';
import {
    EuiButton,
    EuiFlexItem,
    EuiCopy,
    EuiText,
    EuiSpacer,
    EuiFlyout,
    EuiFlyoutHeader,
    EuiFlyoutBody,
    EuiTitle,
} from '@elastic/eui';
import FormGroupDescription from '../../formGroupDescription';
import ButtonGroup from '../../Form/ButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { requestForRiderService } from '../../../api/requestThirdPartyRiderService';
import { getOutletDetails } from '../../../api/outlet/getOutletDetails';

const YulluRider = () => {
    const {
        formState: { errors },
        control,
        watch,
        setValue,
    } = useFormContext();
    const outletId = useSelector((state) => state.outlet.selectedOutletId);
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);
    const dispatch = useDispatch();
    const outlet = useSelector((state) => state.outlet.selectedOutletDetails);
    const approvalDate = outlet?.third_party_rider_setting?.adlogs_yullu_request?.approval_date;
    const serviceStatus = outlet?.third_party_rider_setting?.adlogs_yullu_request?.status;

    const startService = () => {
        dispatch(requestForRiderService('yullu_al', 'rider service request for Yullu')).then((res) => {
            dispatch(getOutletDetails(outletId));
        });
    };
    let flyout;

    if (isFlyoutVisible) {
        flyout = (
            <EuiFlyout ownFocus onClose={() => setIsFlyoutVisible(false)} aria-labelledby={'simpleFlyoutTitle'}>
                <EuiFlyoutHeader hasBorder>
                    <EuiTitle size='m'>
                        <h2 id={'simpleFlyoutTitle'}>Yullu riders</h2>
                    </EuiTitle>
                </EuiFlyoutHeader>
                <EuiFlyoutBody>
                    <ButtonGroup
                        idSelected={watch('is_adlogs_yullu_integration_enabled') ? '1' : '0'}
                        color='primary'
                        control={control}
                        setValue={setValue}
                        name='is_adlogs_yullu_integration_enabled'
                        watch={watch}
                        label={'Yullu integration'}
                    />

                    {/* {watch('is_adlogs_yullu_integration_enabled') ? (
                        <>
                            <TextField
                                errors={errors}
                                label='Yullu API Key'
                                name='yullu_api_key'
                                placeholder='Enter Yullu API Key'
                                rules={{ required: 'Please Enter Yullu API Key' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='Yullu Partner Merchant Id'
                                name='yullu_partner_merchant_id'
                                placeholder='Enter Yullu Partner Merchant Id'
                                rules={{ required: 'Please enter Yullu Partner Merchant Id' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='Yullu call back URL'
                                name='yullu_call_back_url'
                                placeholder='Enter url'
                                control={control}
                                disabled={true}
                                defaultValue={watch('yullu_call_back_url')}
                                append={
                                    <EuiCopy
                                        textToCopy={watch('yullu_call_back_url') ? watch('yullu_call_back_url') : ''}
                                    >
                                        {(copy) => <EuiText onClick={copy}>Copy</EuiText>}
                                    </EuiCopy>
                                }
                            />
                        </>
                    ) : null} */}
                </EuiFlyoutBody>
            </EuiFlyout>
        );
    }

    return (
        <div style={{ maxWidth: '650px' }}>
            <FormGroupDescription
                title={restaurantDescriptions?.yullu_al_riders?.display_name}
                description={restaurantDescriptions?.yullu_al_riders?.description}
            >
                <EuiFlexItem>
                    <EuiButton
                        style={{
                            backgroundColor: serviceStatus === 'approved' && '#228B22',
                            color: serviceStatus === 'approved' && 'white',
                        }}
                        fill
                        onClick={startService}
                        disabled={serviceStatus ? true : false}
                    >
                        {serviceStatus ? serviceStatus : 'START SERVICE'}
                    </EuiButton>
                </EuiFlexItem>
                <EuiSpacer style={{ marginTop: '6px' }}>
                    <EuiText textAlign='center' size='xs'>
                        ------ OR ------
                    </EuiText>
                </EuiSpacer>
                <EuiFlexItem>
                    <EuiButton onClick={() => setIsFlyoutVisible(true)}>CONNECT ACCOUNT</EuiButton>
                </EuiFlexItem>
                {flyout}
            </FormGroupDescription>
            {serviceStatus === 'pending' && (
                <EuiText
                    style={{
                        padding: '8px 12px',
                        background: '#BBB',
                        color: 'white',
                        marginBottom: '12px',
                        borderRadius: '4px',
                    }}
                >
                    <p> Your reqeust has been received and it shall be activated by {approvalDate} </p>
                </EuiText>
            )}
        </div>
    );
};

export default YulluRider;
